/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import { useHistory } from 'react-router';
import utils from '../../../utils/utils';
import WithOnlyOnDesktop from '../../../components/onlyOnDesktop/withOnlyOnDesktop';
import AgencyOpenShifts from './AgencyOpenShifts';
import AgencyAssignedShifts from './AgencyAssignedShifts';
import AgencyPastShifts from './AgencyPastShifts';
import AgencyBundles from './AgencyBundles';

import '../AgencyScreen.scss';
import './AgencySchedule.scss';

const AgencySchedule = () => {
	const history = useHistory();

	const _defaultIndex = Number(utils.getURLQueryParams()?.['tab-index'] || 0);
	const [activeTabIndex, setActiveTabIndex] = useState(_defaultIndex);
	const [searchTerm, setSearchTerm] = useState('');

	const onSearchTermUpdate = (e) => setSearchTerm(e.target.value);
	const clearSearch = () => setSearchTerm('');

	const onChangeTab = (e) => {
		setSearchTerm('');
		setActiveTabIndex(e.index);
		history.push(`${history.location.pathname}?tab-index=${e.index}`);
	};

	return (
		<WithOnlyOnDesktop>
			<div className="external-agency-screen external-agency-schedule">
				<div className="d-flex align-items-center">
					<div className="title flex-one">Schedule</div>
					<span className="global-search-container">
						<input type="text" value={searchTerm} onChange={onSearchTermUpdate} placeholder="Search for..." />
						{searchTerm && <span className="clear-icon" role="img" aria-label="Clear" onClick={clearSearch} />}
					</span>
				</div>
				<TabView activeIndex={activeTabIndex} onTabChange={onChangeTab}>
					<TabPanel header="Open: Per Diem">
						<AgencyOpenShifts searchTerm={searchTerm} />
					</TabPanel>
					<TabPanel header="Open: Bundles">
						<AgencyBundles searchTerm={searchTerm} />
					</TabPanel>
					<TabPanel header="Assigned">
						<AgencyAssignedShifts searchTerm={searchTerm} />
					</TabPanel>
					<TabPanel header="Past">
						<AgencyPastShifts searchTerm={searchTerm} />
					</TabPanel>
				</TabView>
			</div>
		</WithOnlyOnDesktop>
	);
};

export default AgencySchedule;
